var map = {
	"./en.json": [
		"yZm8"
	],
	"./ja.json": [
		"Eizl"
	],
	"./ko.json": [
		"PU8T"
	],
	"./zh.json": [
		"HqTd"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "S/aJ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/lang lazy ^\.\/.*\.json$
// module id = S/aJ
// module chunks = 33